// extracted by mini-css-extract-plugin
export var label = "_j5-2";
export var slideContainer = "_j5-0";
export var slider = "_j5-1";